var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "font-weight-bold text-justify" }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("quick-application.disclaimersText")) + "\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "show-disclaimers-container" },
      _vm._l(_vm.disclaimers, function (ref, index) {
        var mandatory = ref.mandatory
        var consent = ref.consent
        var description = ref.description
        var id = ref.id
        var documentId = ref.documentId
        return _c(
          "b-row",
          {
            key: id,
            staticClass: "w-100 mb-3 align-items-center justify-content-start",
            attrs: { "no-gutters": "" },
          },
          [
            _c(
              "b-col",
              {
                staticClass: "d-flex flex-row",
                attrs: { cols: "11", lg: "8" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "pretty pretty-long-text p-icon p-smooth p-bigger disclaimer-check",
                  },
                  [
                    _c("input", {
                      staticClass: "checkbox",
                      attrs: {
                        id: (consent ? "consent" : "disclaimer") + "-" + index,
                        type: "checkbox",
                        name:
                          (consent ? "consent" : "disclaimer") + "-" + index,
                        "data-unchecked-value": "false",
                      },
                      domProps: { checked: _vm.isAccepted(id), value: id },
                      on: {
                        change: function (value) {
                          return _vm.updateAcceptedConsents(
                            { id: id, consent: consent },
                            value.target.checked
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "state p-primary mr-3" }, [
                      _c("i", { staticClass: "icon material-icons" }, [
                        _vm._v("done"),
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "hidden-text" }, [
                        _vm._v(_vm._s(_vm.$t("application-form.select"))),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "bold disclaimer-description clickable w-100",
                    attrs: {
                      for: (consent ? "consent" : "disclaimer") + "-" + index,
                    },
                  },
                  [
                    _c(
                      "pre",
                      { staticStyle: { "white-space": "pre-line" } },
                      [
                        mandatory | consent
                          ? _c("input-required-indicator")
                          : _vm._e(),
                        _vm._v(" "),
                        consent
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("quick-application.consentForm")
                                  ) +
                                  ": "
                              ),
                            ])
                          : _vm._e(),
                        !mandatory
                          ? _c("span", [
                              _vm._v(
                                " (" +
                                  _vm._s(_vm.$t("global.words.optional")) +
                                  ") "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(_vm._s(description) + ". "),
                        documentId
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "ml-1 pl-0 download-disclaimer-text",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$tc("global.words.click", 1)) + " "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "clickable bold text-secondary download-disclaimer download-disclaimer-link",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.handleDownloadConsent(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("global.words.here")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("global.words.to")) + " "
                                ),
                                _c("span", { staticClass: "text-lowercase" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("global.words.download"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.isFrenchLanguage
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("documents.theDocument"))
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(". "),
                                _vm.loadingDisclaimers
                                  ? _c("inline-loader")
                                  : _vm._e(),
                                _vm._v("\n          "),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        )
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }